import { Pipe, PipeTransform } from '@angular/core';

import { ChipVariants } from '../../shared/components/chip/chip.component';
import { ÉTAT_GROUPE, étatGroupeOrdre } from '../enum/état-groupe.enum';
import { Groupe } from '../models/groupe.model';

@Pipe({
  name: 'getEtatEtapeVariant',
})
export class GetEtatEtapeVariantPipe implements PipeTransform {
  transform(groupes?: Groupe[]): ChipVariants['variant'] {
    if (!groupes || !groupes.length) return 'default';

    const état = groupes
      .map((x) => x.etat)
      .reduce((min, current) => (étatGroupeOrdre[current] < étatGroupeOrdre[min] ? current : min));

    switch (état) {
      case ÉTAT_GROUPE.A_FAIRE:
        return 'default';
      case ÉTAT_GROUPE.A_VALIDER:
        return 'informative';
      case ÉTAT_GROUPE.VALIDE:
        return 'positive';
      case ÉTAT_GROUPE.REJETE:
        return 'negative';
    }
  }
}
